import { qdfoodApi } from './constant';
import { IClient } from '@type/client';

export const CLIENT_API = {
  urlGetClient: `/client/list/web-user`,
};

export default class clientApi {
  static getClient() {
    return qdfoodApi().get<IClient[]>(CLIENT_API.urlGetClient, {
      params: {
        isDeleted: false,
      },
    });
  }
}
